import { IOrganizationAssetsTable } from 'types/interfaces';

export const assetsTableMock: IOrganizationAssetsTable[] = [
    {
        rank: 1,
        protocolName: 'Uniswap',
        protocolType: 'DEX',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 45218900,
        protocolValuePercentage: 22.5,
    },
    {
        rank: 2,
        protocolName: 'Aave',
        protocolType: 'Lending',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 38765000,
        protocolValuePercentage: 19.3,
    },
    {
        rank: 3,
        protocolName: 'Compound',
        protocolType: 'Lending',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 28542000,
        protocolValuePercentage: 14.2,
    },
    {
        rank: 4,
        protocolName: 'Curve Finance',
        protocolType: 'DEX',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 24567000,
        protocolValuePercentage: 12.2,
    },
    {
        rank: 5,
        protocolName: 'Lido',
        protocolType: 'Staking',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 19875000,
        protocolValuePercentage: 9.9,
    },
    {
        rank: 6,
        protocolName: 'MakerDAO',
        protocolType: 'CDP',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 15632000,
        protocolValuePercentage: 7.8,
    },
    {
        rank: 7,
        protocolName: 'SushiSwap',
        protocolType: 'DEX',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 12456000,
        protocolValuePercentage: 6.2,
    },
    {
        rank: 8,
        protocolName: 'Yearn Finance',
        protocolType: 'Yield',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 9875000,
        protocolValuePercentage: 4.9,
    },
    {
        rank: 9,
        protocolName: 'Balancer',
        protocolType: 'DEX',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 8765000,
        protocolValuePercentage: 4.4,
    },
    {
        rank: 10,
        protocolName: 'Synthetix',
        protocolType: 'Derivatives',
        protocolChainId: '1',
        protocolChainTitle: 'Ethereum',
        totalValue: 7654000,
        protocolValuePercentage: 3.8,
    },
    {
        rank: 11,
        protocolName: 'Uniswap (Arbitrum)',
        protocolType: 'DEX',
        protocolChainId: '42161',
        protocolChainTitle: 'Arbitrum',
        totalValue: 6543000,
        protocolValuePercentage: 3.3,
    },
    {
        rank: 12,
        protocolName: 'Aave (Polygon)',
        protocolType: 'Lending',
        protocolChainId: '137',
        protocolChainTitle: 'Polygon',
        totalValue: 5432000,
        protocolValuePercentage: 2.7,
    },
    {
        rank: 13,
        protocolName: 'PancakeSwap',
        protocolType: 'DEX',
        protocolChainId: '56',
        protocolChainTitle: 'BNB Chain',
        totalValue: 4321000,
        protocolValuePercentage: 2.2,
    },
    {
        rank: 14,
        protocolName: 'Trader Joe',
        protocolType: 'DEX',
        protocolChainId: '43114',
        protocolChainTitle: 'Avalanche',
        totalValue: 3210000,
        protocolValuePercentage: 1.6,
    },
    {
        rank: 15,
        protocolName: 'Quickswap',
        protocolType: 'DEX',
        protocolChainId: '137',
        protocolChainTitle: 'Polygon',
        totalValue: 2100000,
        protocolValuePercentage: 1.0,
    },
];
